import {Color} from "three";

export const MATERIAL_PROPS_DB = [
    /*  {
          materialName: 'WallMat',
          emmissiveIntensity: .81, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: 0.58, //Ambient occlusion
          envMapIntensity: .25
      },

      {
          materialName: 'CeilingMat',
          emmissiveIntensity: .4, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: 0.35, //Ambient occlusion
      },

      {
          materialName: 'CeilingMetalBars',
          // emmissiveIntensity:1, //Emissive intensity
          // emmisiveColor:new Color(0x000000),
          aOIntensity: .5, //Ambient occlusion
      },

      {
          materialName: 'PillarMat',
          emmissiveIntensity: .7, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: .5, //Ambient occlusion
      },

      {
          materialName: 'LampEmmisiveMat',
          emmissiveIntensity: .5, //Emissive intensity
          emmisiveColor: new Color(0xD9B37C),
          aOIntensity: 1, //Ambient occlusion
      },


      {
          materialName: 'FloorMat',
          /!* emmissiveIntensity:.5, //Emissive intensity
           emmisiveColor:new Color(0xD9B37C),*!/
          aOIntensity: .64, //Ambient occlusion
      },

      {
          materialName: 'WindowDoorMat',
          /!* emmissiveIntensity:.5, //Emissive intensity
           emmisiveColor:new Color(0xD9B37C),*!/
          aOIntensity: .1, //Ambient occlusion
      },

      {
          materialName: 'LampWireMat',
          emmissiveIntensity: 1.5, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          // aOIntensity:.1, //Ambient occlusion
      },

      {
          materialName: 'PlinthCatalogMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.1, //Ambient occlusion
      },

      {
          materialName: 'UVT43Mat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.25, //Ambient occlusion
      },

      {
          materialName: 'DomeFloorMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.6, //Ambient occlusion
      },

      {
          materialName: 'DoorOnlyMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          envMapIntensity: 1.6,
          aOIntensity: 1, //Ambient occlusion
      },*/

   /* {
        materialName: 'FloorMat',

        aOIntensity: .511, //Ambient occlusion
        envMapIntensity: 0.58,
        useMapAsLightMap:'Y',

    },


    {
        materialName:"WallsMat",
        aOIntensity:0.8383327639221044,
        emmisiveColor:
            new Color( 0.0028639789670705795, 0.0028639789670705795, 0.0028639789670705795 ),
        emmissiveIntensity:1,
        envMapIntensity:4.026135975401434,
        lightMapIntensity:4.002391527160915,
        useMapAsLightMap:'Y',

    },
    {
        materialName:"CelingMat",
        aOIntensity:0.5775538093611207,
        emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1,
        envMapIntensity:2.9547318073112403,
        lightMapIntensity:2.1438332763922103,
        useMapAsLightMap:'Y',
    },
    {
        materialName: 'DoorFrameMat',
        /!* emmissiveIntensity: .4, //Emissive intensity
         emmisiveColor: new Color(0xFFFFFF),*!/
        aOIntensity: 0.51, //Ambient occlusion
        envMapIntensity: 2,
        useMapAsLightMap:'Y',
        roughness: .08,
    },*/



        {
            materialName:"FloorMat",

            roughness:0.2633779264214047,
            aOIntensity:0.8860383322937655,
            envMapIntensity:0.7191083447359226,

        },
        {
            materialName:"OuterWallMat",
            aOIntensity:0.9823465059092082,

            envMapIntensity:3.4918060200668894,

        },
        {
            materialName:"ArchWallMat",
            aOIntensity:0.34063545150501673,

            envMapIntensity:3.6416387959866223,

        },

]



  /*  [
    {
        materialName:"FloorMat",
        aOIntensity:0.8860383322937655,
        emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1,
        envMapIntensity:0.7191083447359226,
        lightMapIntensity:1,
        roughness:0.2633779264214047,
        toneMapped:true,
    },
        {
            materialName:"OuterWallMat",
            aOIntensity:0.9823465059092082,
            emmisiveColor:
                new Color( 0, 0, 0 ),
            emmissiveIntensity:1,
            envMapIntensity:3.4918060200668894,
            lightMapIntensity:1,
            roughness:1,
            toneMapped:true,
        },

    ]*/



